import { Calculator, MoreHorizontal } from "lucide-react";
import { useLocation, useNavigate } from "react-router";
import { cn } from "@repo/exit-calc-web-utils";

interface Tab {
  label: string;
  icon: React.ComponentType<{ className?: string }>;
  path: string;
  match: (pathname: string) => boolean;
}

const TABS: Tab[] = [
  {
    label: "계산기",
    icon: Calculator,
    path: "/",
    match: (pathname) =>
      pathname === "/" || pathname.startsWith("/calculators"),
  },
  {
    label: "더보기",
    icon: MoreHorizontal,
    path: "/more",
    match: (pathname) => pathname.startsWith("/more"),
  },
];

export function BottomTab() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <nav
      className="sticky bottom-0 z-20 flex shrink-0 border-t border-border bg-background"
      style={{
        height: `calc(56px + var(--safe-area-inset-bottom))`,
        paddingBottom: "var(--safe-area-inset-bottom)",
      }}
    >
      {TABS.map((tab) => {
        const isActive = tab.match(location.pathname);
        const Icon = tab.icon;

        return (
          <button
            key={tab.label}
            type="button"
            className={cn(
              "flex flex-1 flex-col items-center justify-center gap-0.5 pt-1.5",
              isActive ? "text-primary" : "text-muted-foreground",
            )}
            onClick={() => navigate(tab.path)}
          >
            <Icon className="h-5 w-5" />
            <span className="text-[10px] font-medium">{tab.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
